import { humanizeGemLabel } from "../constants/gems";
import { formatKeyCostLines } from "../constants/keys";
import PotionBannerTitle from "./PotionBannerTitle";
import potionArabesqueSrc from "../assets/arabesquepotion.svg";

function buildGemImageUrl(gemId) {
  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/gems/${encodeURIComponent(`${gemId}.png`)}`;
}

export default function KeyCard({ keyItem, quantity = 0, affinityGem, canObtain = false, onObtain }) {
  const gemId = keyItem.cost.specificGemId;
  const gemLabel = affinityGem?.label ?? humanizeGemLabel(`${gemId}.png`);
  const gemImageUrl = affinityGem?.imageUrl ?? buildGemImageUrl(gemId);
  const gemCount = keyItem.cost.specificGemCount ?? 1;
  const gemTooltipId = `key-gem-tooltip-${keyItem.id}`;
  const costLines = formatKeyCostLines(keyItem);

  return (
    <article
      className={`potion-card key-card ${keyItem.themeClass}${
        canObtain ? " key-card--can-obtain" : ""
      }`}
    >
      <div className="potion-card__crest">
        <h3 className="potion-card__title">{keyItem.name}</h3>
        <PotionBannerTitle name={keyItem.name} />
        <div className="potion-card__visual">
          <div className="potion-card__icon-wrap">
            <img
              src={keyItem.image}
              alt=""
              className="key-card__image"
              decoding="sync"
              draggable={false}
            />
          </div>
        </div>
      </div>

      <div className="potion-card__description-wrap">
        <p className="potion-card__description">{keyItem.description}</p>

        <img
          src={potionArabesqueSrc}
          alt=""
          className="potion-card__arabesque"
          draggable={false}
          aria-hidden="true"
        />

        <div className="potion-card__actions">
          <div className="potion-card__cost-block">
            <div className="potion-card__cost">
              <p className="potion-card__cost-line potion-card__cost-line--price">
                <span className="potion-card__cost-label">Prix&nbsp;:</span>
                <span
                  className="potion-card__price-gem"
                  aria-label={`${gemCount} ${gemLabel}`}
                >
                  <span className="potion-card__price-count">{gemCount}</span>
                  <span className="potion-card__gem-wrap">
                    <img
                      src={gemImageUrl}
                      alt=""
                      className="potion-card__gem-icon"
                      decoding="sync"
                      draggable={false}
                      tabIndex={0}
                      aria-describedby={gemTooltipId}
                    />
                    <span id={gemTooltipId} className="potion-card__gem-tooltip" role="tooltip">
                      {gemLabel}
                    </span>
                  </span>
                </span>
              </p>
              <p className="potion-card__cost-line potion-card__cost-line--secondary">
                {costLines.commonPart}
              </p>
            </div>
          </div>

          <button
            type="button"
            className="potion-card__obtain"
            disabled={!canObtain}
            onClick={() => onObtain?.(keyItem)}
          >
            Obtenir
          </button>
        </div>
      </div>

      <div className="potion-card__quantity">
        {quantity > 0 ? (
          <>
            <span className="potion-card__quantity-label">Vous en possédez</span>
            <strong className="potion-card__quantity-value">{quantity}</strong>
          </>
        ) : (
          <span className="potion-card__quantity-label">
            Vous ne possédez pas ce parchemin
          </span>
        )}
      </div>
    </article>
  );
}
